import { render, staticRenderFns } from "./ModalMoveActivitesFromDomain.vue?vue&type=template&id=57abf10a"
import script from "./ModalMoveActivitesFromDomain.vue?vue&type=script&lang=js"
export * from "./ModalMoveActivitesFromDomain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports